export const SET_GLOBAL_AC_FILTERS_DATA = 'SET_GLOBAL_AC_FILTERS_DATA';
export const SET_SCREEN_AC_FILTERS_DATA = 'SET_SCREEN_AC_FILTERS_DATA';
